/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DeepLinkLTIDataParser = /* #__PURE__ */ parsers.object([
    ['authToken', codecString, 'auth_token'],
    ['name', codecString],
    ['deadline', parsers.moment],
    [
        'lockDate',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(parsers.moment)),
        'lock_date',
    ],
    [
        'availableAt',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(parsers.moment)),
        'available_at',
    ],
]);
export class DeepLinkLTIData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DeepLinkLTIDataParser.decode(input).map(res => new DeepLinkLTIData(res));
    }
    static unsafeDecode(input) {
        return DeepLinkLTIData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DeepLinkLTIDataParser.encode(data);
    }
    static schema() {
        return DeepLinkLTIDataParser.schema();
    }
}
